module.exports = __webpack_public_path__ + "static/media/rockWallSheetCave.9b2a8c82.png";